import { Directive, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/UserService';

@Directive ({
	selector: 'logged-in',
	standalone: false,
})
export class LoggedInDirective implements OnInit {

	constructor(private userService: UserService, private router: Router) {
	}

	async ngOnInit(): Promise<void> {
		try {
			await this.userService.checkSession();
		} catch {
			this.userService.detouredRoute = this.router.url;
			this.router.navigate(['/login']);
		}
	}
}
